module.exports = {
  name: 'booking-add-ons',
  settings: {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    cssEase: 'linear',
    variableWidth: true,
    responsive: [
      {
        breakpoint: 'xxl',
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 'xl',
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 'lg',
        settings: {
          slidesToShow: 3.33,
        }
      },
      {
        breakpoint: 'md',
        settings: {
          slidesToShow: 2.33,
        }
      },
      {
        breakpoint: 'sm',
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 'xs',
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  },
}
